import { render, staticRenderFns } from "./RelatorioPedidoGeralCotas.vue?vue&type=template&id=b6353056"
import script from "./RelatorioPedidoGeralCotas.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoGeralCotas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports